import l from "./index232.js";
import { resolveComponent as t, createElementBlock as i, openBlock as a, normalizeClass as p, createElementVNode as o, createTextVNode as m, toDisplayString as u, createVNode as n, renderSlot as f } from "vue";
/* empty css         */
import _ from "./index231.js";
const b = ["data-component"], h = ["id", "checked"], k = ["for"], g = { class: "flex items-center justify-center custom-icon-size group-hover:bg-color-brand-beige-100 rounded-normal" }, y = { class: "body" }, v = { class: "pb-16" };
function C(e, s, I, $, w, B) {
  const r = t("ms-minus"), c = t("ms-plus");
  return a(), i("div", {
    "data-component": e.$options.name,
    class: p({ "border-b border-solid border-color-greyscale-100": e.hasBorder })
  }, [
    o("input", {
      id: e.computedId,
      ref: "inputRef",
      type: "checkbox",
      checked: e.isInitiallyOpen,
      class: "absolute input",
      onChange: s[0] || (s[0] = (...d) => e.trackClick && e.trackClick(...d))
    }, null, 40, h),
    o("label", {
      for: e.computedId,
      class: "flex items-center justify-between font-bold cursor-pointer select-none custom-padding label text-text-l group rounded-normal"
    }, [
      m(u(e.label) + " ", 1),
      o("span", g, [
        n(r, { class: "w-24 h-24 closeIcon" }),
        n(c, { class: "w-24 h-24 openIcon" })
      ])
    ], 8, k),
    o("div", y, [
      o("div", v, [
        f(e.$slots, "default", {}, void 0, !0)
      ])
    ])
  ], 10, b);
}
const E = /* @__PURE__ */ _(l, [["render", C], ["__scopeId", "data-v-3f48c70d"]]);
export {
  E as default
};
